/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubMenu } from '../../models/sub-menu';
import { SubMenuApiRespModel } from '../../models/sub-menu-api-resp-model';

export interface ApiMasterSubMenuEditPost$Params {
      body?: SubMenu
}

export function apiMasterSubMenuEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterSubMenuEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubMenuApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterSubMenuEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubMenuApiRespModel>;
    })
  );
}

apiMasterSubMenuEditPost.PATH = '/api/Master/SubMenu/Edit';
